import { observer } from 'mobx-react';
import { FC } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { Card } from '@monorepo/base/src/components/card/card';
import { Input } from '@monorepo/base/src/components/form/input/input';
import { IAdminxStore } from '../../../../stores';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';

export const BudgetLimitTotal: FC = observer(() => {
	const { campaignStore } = useStores<IAdminxStore>();
	const campaignCrudStore = campaignStore.getCrud();
	const campaign = campaignCrudStore.getData();

	const limit = campaign
		.getPhases()
		.filter(p => p.active)
		?.reduce((acc, i) => acc + (i?.daily_budget?.limit || 0), 0)
		?.toString();

	return (
		<Card
			id={'dailyBudget'}
			title={'Daily Budget'}
			icon={'currency-dollar-circle'}
			debugProps={{ dataAttrs: [new DataAttribute('id', 'daily_budget_section')] }}>
			<Input
				disabled
				type={'number'}
				icon={'currency-dollar'}
				value={limit}
				placeholder={'Limit'}
				debugProps={{ dataAttrs: [new DataAttribute('id', 'daily_budget')] }}
			/>
		</Card>
	);
});
